export default {
    Email: '',
    Password: '',
    KeepConnected: true,
};
